import React from 'react';
import Button from '../../ui/buttons/Button';
import IndicationForm from './IndicationForm';

const newTempId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const IndicationFormList = ({ indications, onChange, canWrite = true }) => {
  const visible = indications.map((i, originalIndex) => ({ ...i, _idx: originalIndex })).filter((i) => !i._destroy);

  const handleChange = (originalIndex, updated) => {
    const updatedList = [...indications];
    updatedList[originalIndex] = updated;
    onChange(updatedList);
  };

  const handleAdd = () => {
    onChange([
      ...indications,
      {
        tempId: newTempId(),
        name: '',
        email: '',
        phone: '',
        _destroy: false,
      },
    ]);
  };

  const handleRemove = (originalIndex) => {
    const updatedList = [...indications];
    const item = updatedList[originalIndex];

    if (item?.id) {
      updatedList[originalIndex] = { ...item, _destroy: true };
    } else {
      updatedList.splice(originalIndex, 1);
    }
    onChange(updatedList);
  };

  return (
    <>
      <div className="space-y-4 bg-tealWhisper rounded-xl border border-tealPale p-5">
        {visible.map(({ _idx, ...indication }) => (
          <div
            key={indication.id || indication.tempId}
            className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6"
          >
            <IndicationForm
              index={_idx} // índice do array original
              indication={indication}
              onChange={handleChange}
              onRemove={handleRemove}
              canWrite={canWrite}
            />
          </div>
        ))}
      </div>

      {canWrite && (
        <div className="pt-4">
          <Button onClick={handleAdd} type="button">
            + ADICIONAR INDICAÇÃO
          </Button>
        </div>
      )}
    </>
  );
};

export default IndicationFormList;
